import React from "react";
import { Select } from "Components/Base/Inputs/Select";
import { MenuItem } from "Components/Base/Inputs/MenuItem";
import { InputLabel } from "Components/Base/Inputs/InputLabel";
import { FormControl } from "Components/Base/Inputs/FormControl";

const SelectFilter = ({
  name,
  options,
  value,
  onChange,
  className = "",
  fullWidth = false,
  displayLabel = true,
  sx,
  languageContext,
  translateOptions = false,
}) => {
  return (
    <FormControl
      className={`filter-select ${className}`}
      fullWidth={fullWidth}
      sx={sx}
    >
      {displayLabel && <InputLabel id={`${name}-label`}>{name}</InputLabel>}
      <Select
        labelId={`${name}-label`}
        id={name}
        aria-label={name}
        name={name}
        value={value || 0}
        onChange={(e) => onChange(e.target.value)}
        className={className}
        label={name}
        displayEmpty
        sx={sx}
      >
        {options.map((option) => (
          <MenuItem key={`SctF_${option.value}`} value={option.value}>
            {translateOptions ? languageContext(option.label) : option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectFilter;
